import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import { initAutoUpdate } from './autoUpdate';
import { registerSW } from './pwa';
import { instalarTelemetria } from './services/telemetry';

// Uso por sección + errores en pantalla (services/telemetry.ts, 1-oct-2026).
instalarTelemetria();

// Los <input type="number"> cambian de valor con la RUEDA del mouse (si están
// enfocados) y con las flechas ↑/↓ — causó cortes de caja con 39.97 en vez de 40
// en la agenda dental (2-jul). Se neutraliza globalmente: la rueda suelta el foco
// (el scroll sigue moviendo la página) y las flechas no hacen stepping.
document.addEventListener('wheel', () => {
  const el = document.activeElement;
  if (el instanceof HTMLInputElement && el.type === 'number') el.blur();
}, { capture: true, passive: true });
document.addEventListener('keydown', (e) => {
  const el = e.target;
  if ((e.key === 'ArrowUp' || e.key === 'ArrowDown') &&
      el instanceof HTMLInputElement && el.type === 'number') {
    e.preventDefault();
  }
}, true);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <ToastProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>
);

// Auto-actualización sin botón: la pestaña se recarga sola al detectar un deploy nuevo.
initAutoUpdate();

// Service worker (instalabilidad PWA + push). No cachea el shell.
registerSW();
